import { useBoundRef } from '#pplx/frontend/common/hooks/useBoundRef.js';
import { useCallback, useEffect, useRef } from 'react';
export function useDeferredEffect(callback, deps) {
    const ref = useRef(false);
    const rCallback = useBoundRef(callback);
    useEffect(() => {
        if (!ref.current)
            return;
        rCallback.current();
        ref.current = false;
        // disable this so we can spread the deps (and not re-render on every change to the array)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rCallback, ...deps]);
    return useCallback(() => {
        ref.current = true;
    }, []);
}
//# sourceMappingURL=useDeferredEffect.js.map